<template>
	<div v-if="loaded" dir="rtl" lang="he">
		<router-view />
	</div>
</template>

<style lang="scss"></style>

<script>
export default {
	data() {
		return {
			loaded: false,
		};
	},
	mounted() {
		document.documentElement.setAttribute('dir', 'rtl');
		document.documentElement.setAttribute('lang', 'he');

		const tokenDate = localStorage.getItem('user_token_date');
		const twoHours = 1000 * 60 * 60 * 2;

		if (tokenDate && Date.now() - parseInt(tokenDate) > twoHours) {
			localStorage.removeItem('user_token');
			localStorage.removeItem('user_token_date');
			localStorage.removeItem('user_inner_token');
			localStorage.removeItem('require_password_setup');
		}

		this.api({ action: 'general', method: 'get' }, (data) => {
			const { words } = data.data;
			this.$store.commit('setWords', { words });
			this.loaded = true;
		});
	},
};
</script>
